import React from 'react';
import { Link } from '@remix-run/react';
import { Badge } from '~/components/ui/badge';

interface TagListProps {
  tags: string[];
}

export function TagList({ tags }: TagListProps) {
  return (
    <div className="flex flex-wrap gap-2">
      <span className="text-sm font-semibold">Tags:</span>
      {tags.map((tag) => (
        <Link
          key={tag}
          to={`/blog?tag=${encodeURIComponent(tag.toLowerCase())}`}
        >
          <Badge
            variant="secondary"
            className="hover:bg-primary/20 cursor-pointer transition-colors"
          >
            {tag}
          </Badge>
        </Link>
      ))}
    </div>
  );
}